"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.configureArc = exports.configureTickData = exports.configureTicks = exports.configureScale = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _d = require("d3"),
    _util = require("../util"),
    configureScale = (0, _memoizeOne["default"])(_configureScale);

exports.configureScale = configureScale;
var configureTicks = (0, _memoizeOne["default"])(_configureTicks);
exports.configureTicks = configureTicks;
var configureTickData = (0, _memoizeOne["default"])(_configureTickData);
exports.configureTickData = configureTickData;
var configureArc = (0, _memoizeOne["default"])(_configureArc);
exports.configureArc = configureArc;

function _configureScale(a) {
  return (0, _util.calculateScale)({
    min: a.minValue,
    max: a.maxValue,
    segments: a.maxSegmentLabels
  });
}

function _configureTicks(a) {
  var b = configureScale(a),
      c = (0, _util.calculateTicks)(b, {
    min: a.minValue,
    max: a.maxValue,
    segments: a.maxSegmentLabels
  });
  return 0 < a.customSegmentStops.length && 0 !== a.maxSegmentLabels && (c = a.customSegmentStops), c;
}

function _configureTickData(a) {
  var b = (0, _d.range)(a.majorTicks).map(function () {
    return 1 / a.majorTicks;
  }),
      c = (0, _util.calculateSegmentStops)({
    tickData: b,
    customSegmentStops: a.customSegmentStops,
    min: a.minValue,
    max: a.maxValue
  });
  return c;
}

function _configureArc(a) {
  var b = configureTickData(a),
      c = a.maxAngle - a.minAngle,
      d = a.width / 2,
      e = (0, _d.arc)().innerRadius(d - a.ringWidth - a.ringInset).outerRadius(d - a.ringInset).startAngle(function (e, d) {
    var f = (0, _util.sumArrayTill)(b, d);
    return (0, _util.deg2rad)(a.minAngle + f * c);
  }).endAngle(function (e, d) {
    var f = (0, _util.sumArrayTill)(b, d + 1);
    return (0, _util.deg2rad)(a.minAngle + f * c);
  });
  return e;
}